'use client';

import React from 'react';
import { useTranslation } from 'next-i18next';
import BestieAvatar from '@components/templates/bestie/BestieAvatar';

/**
 * BestieWelcome
 *
 * Displays the animated Bestie AI avatar and a localized welcome message.
 * Used as the introductory visual when the user enters the Audio Interview flow.
 *
 * Features:
 *  - Animated avatar with decorative background pulse
 *  - Welcoming message box, localized via i18n
 */
export const BestieWelcome: React.FC = () => {
  const { t } = useTranslation('common');

  return (
    <div className="flex flex-col items-center space-y-6">
      {/* Bestie Avatar */}
      <BestieAvatar className="size-48 border-2 border-secondary" />

      {/* Welcome Message */}
      <div className="max-w-sm rounded-2xl bg-surface-200 px-6 py-4 shadow-lg">
        <p className="text-center text-lg font-medium text-ink">
          {t('audio-interview.bestie.message')}
        </p>
      </div>
    </div>
  );
};

